import { ReactElement } from 'react';

const LightThemeIcon = (props: TClassNameProps): ReactElement => (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
		<path
			d="M9.00117 13.8C11.6521 13.8 13.8012 11.6509 13.8012 8.99995C13.8012 6.34898 11.6521 4.19995 9.00117 4.19995C6.3502 4.19995 4.20117 6.34898 4.20117 8.99995C4.20117 11.6509 6.3502 13.8 9.00117 13.8Z"
			stroke="#6A737C"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M14.712 14.712L14.608 14.608M14.608 3.392L14.712 3.288L14.608 3.392ZM3.288 14.712L3.392 14.608L3.288 14.712ZM9 1.064V1V1.064ZM9 17V16.936V17ZM1.064 9H1H1.064ZM17 9H16.936H17ZM3.392 3.392L3.288 3.288L3.392 3.392Z"
			stroke="#6A737C"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default LightThemeIcon;
